"use client";

import viugoTrendDown from "@/assets/images/viugo/kbv-v16-trend-arrow-down.svg";
import viugoTrendUp from "@/assets/images/viugo/kbv-v16-trend-arrow-up.svg";
import { hasDirectionalTrend, isValidOddValue, normalizeTrend } from "./ViuGoTrendUtils";

function TrendArrow({ isDown, svgClassName = "" }) {
    const cls = ["shrink-0", svgClassName.trim()].filter(Boolean).join(" ");
    return (
        <img
            src={isDown ? viugoTrendDown : viugoTrendUp}
            alt=""
            width={6}
            height={5}
            className={cls}
            aria-hidden
        />
    );
}

export default function ViuGoOddsMatch1x2Cell({
    value,
    trend,
    valueClassName = "text-[12px] leading-[12px]",
    rowClassName = "",
    trendArrowClassName = "",
    compact = false,
}) {
    const normalizedTrend = normalizeTrend(trend);
    const isDown = normalizedTrend === "down";
    const display = isValidOddValue(value) ? value : "-";

    if (!compact) {
        return (
            <div
                className={`block w-full min-w-0 !w-full !min-w-0 !flex items-center justify-end gap-[3px] rounded-[2px] px-1 py-[2px] font-normal ${valueClassName} ${isDown ? "kbv-bg-odds-positive-indigo-slate" : "kbv-bg-odds-neutral-indigo-slate"
                    } ${rowClassName}`.trim()}
            >
                {display}
                {isValidOddValue(display) && <TrendArrow isDown={isDown} />}
            </div>
        );
    }

    return (
        <div
            className={`flex min-w-0 w-full max-w-full items-center justify-center gap-[3px] rounded-[2px] px-1 py-[2px] font-normal ${valueClassName} ${isDown ? "kbv-bg-odds-positive-indigo-slate" : "kbv-bg-odds-neutral-indigo-slate"
                } ${rowClassName}`.trim()}
        >
            <span className="min-w-0 max-w-full truncate text-center tabular-nums">
                {display}
            </span>
            {isValidOddValue(display) && hasDirectionalTrend(trend) && (
                <TrendArrow isDown={isDown} svgClassName={trendArrowClassName} />
            )}
        </div>
    );
}
